// Service Worker Registration para ATELIER JPM - PWA
// Este archivo maneja el registro y actualización del Service Worker

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export function register(config) {
  if ('serviceWorker' in navigator) {
    // El service worker solo funciona en producción o con HTTPS
    const publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href);
    
    if (publicUrl.origin !== window.location.origin) {
      // El SW no funcionará si PUBLIC_URL está en un origen diferente
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = '/sw.js';

      if (isLocalhost) {
        // En localhost, verificar si el SW existe
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log(
            '[PWA] Esta app está siendo servida desde caché por un service worker. ' +
            'Más info: https://cra.link/PWA'
          );
        });
      } else {
        // No es localhost. Registrar SW directamente
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('[PWA] Service Worker registrado exitosamente:', registration.scope);
      
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Nuevo contenido disponible; por favor actualice
              console.log(
                '[PWA] Nuevo contenido disponible y será usado cuando todas ' +
                'las pestañas de esta página se cierren.'
              );

              // Ejecutar callback de actualización
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // Contenido pre-cacheado para uso offline
              console.log('[PWA] Contenido cacheado para uso offline.');

              // Ejecutar callback de éxito
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('[PWA] Error durante el registro del Service Worker:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Verificar si el service worker existe
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Asegurar que el SW existe y que estamos obteniendo un archivo JS
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No se encontró SW. Probablemente una app diferente. Recargar la página
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // SW encontrado. Proceder con registro normal
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        '[PWA] No hay conexión a internet. La app está corriendo en modo offline.'
      );
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[PWA] Error al desregistrar SW:', error.message);
      });
  }
}

// Función para forzar actualización del SW
export function forceUpdate() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.update();
    });
  }
}

// Función para verificar si la app es instalable
export function checkInstallable(callback) {
  let deferredPrompt = null;
  
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevenir que Chrome muestre el prompt automáticamente
    e.preventDefault();
    // Guardar el evento para usarlo después
    deferredPrompt = e;
    
    if (callback) {
      callback(true, deferredPrompt);
    }
  });

  // Detectar si ya está instalada
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    console.log('[PWA] App instalada exitosamente');
    if (callback) {
      callback(false, null);
    }
  });

  // Verificar si ya está en modo standalone (instalada)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    console.log('[PWA] App corriendo en modo standalone (instalada)');
    if (callback) {
      callback(false, null);
    }
  }
}
